import { render, staticRenderFns } from "./PostForm.vue?vue&type=template&id=39eb688e&scoped=true"
import script from "./PostForm.vue?vue&type=script&lang=js"
export * from "./PostForm.vue?vue&type=script&lang=js"
import style0 from "./PostForm.vue?vue&type=style&index=0&id=39eb688e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eb688e",
  null
  
)

export default component.exports